import React from "react";
import './IiifPlayer.scss';
//import { Viewer } from "react-iiif-viewer"

function IiifPlayer({url}) {
  return '';//<Viewer iiifUrl={url} />;
}

export default IiifPlayer;
